import { render, staticRenderFns } from "./SignUpForm.vue?vue&type=template&id=0f699a84"
import script from "./SignUpForm.js?vue&type=script&lang=js&external"
export * from "./SignUpForm.js?vue&type=script&lang=js&external"
import style0 from "./SignUpForm.vue?vue&type=style&index=0&id=0f699a84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports